const mPaginationSecondary = {
  mPaginationSecondary: {
    alerts: {
      showLoadingState: {
        loading: 'Cargando Datos...'
      }
    }
  }
}

export default mPaginationSecondary
